module.exports = __webpack_public_path__ + "img/daley.75c92cb3.jpg";